import { DispensingPropertiesDTO } from 'business/models/Models';
import { IGeneralDispensingPropertiesData } from 'components/main/Setup/DispensingProperties/constants';

export const transformGeneralDispensingPropertiesToRequest = (
  properties: IGeneralDispensingPropertiesData,
): DispensingPropertiesDTO => {
  return DispensingPropertiesDTO.fromJS(properties);
};
